import React, { useCallback, useState } from 'react';
import { Bridge, LocationType } from '@nackle/bridge';
import auth from '../auth/auth';
import { authService } from '../auth/authService';

export const BridgeAndProvider = ( { signInRedirect, ...otherProps } ) => {
    const [ authState, setAuthState ] = useState();

    // const setOptions = useCallback( async ( authState ) => {
    //     await setHeaders( {
    //         authorization: `Bearer ${ authState.access_token }`,
    //         'company-id': authState.claims.company_id,
    //         'person-id': authState.claims.person_id,
    //     } );
    // }, [] );

    /**
     * Handles any necessary updates when the user's auth state changes.
     */
    const handleAuthStateUpdate = useCallback( async ( state ) => {
        setAuthState( state );
        // setOptions( state );
    }, [ setAuthState ] );

    const onError = useCallback( ( error ) => {
        console.error( error );
    }, [] );

    /**
     * Handles where to redirect the user when Bridge attempts to redirect.
     */
    const handleSetLocation = ( args ) => {
        switch ( args.type ) {
            case LocationType.SIGN_IN: {
                if ( signInRedirect ) {
                    args.location = signInRedirect;
                }
                break;
            }
        }
    };

    const hasCompanyId = !!authState?.delegate?.claims?.company_id || !!authState?.claims?.company_id;

    const { Provider } = authService.context;

    return (
        <Bridge
            auth={ auth }
            onSignIn={ handleAuthStateUpdate }
            onSignOut={ handleAuthStateUpdate }
            onRefresh={ handleAuthStateUpdate }
            onError={ onError }
            onSetLocation={ handleSetLocation }
        >
            { /* Gives all children easy access to the current auth state if they want it. */ }
            { ( hasCompanyId ) &&
                <Provider value={ authState }>
                    { ( typeof otherProps.children === 'function' )
                        ? otherProps.children( authState )
                        : otherProps.children
                    }
                </Provider>
            }
        </Bridge>
    );
};
